import { webhookClient } from '../../../../utils/webhookClient';

export const createServedOrderAfterPayment = async (cartData: any) => webhookClient.postAnon(`ordering-system/order-served`, cartData);

export const createTakeAwayOrderAfterPayment = async (cartData: any) => webhookClient.postAnon(`ordering-system/order-takeaway`, cartData);

export const createTakeAwayOrderPayment = async (cartData: any) => webhookClient.postAnon(`ordering-system/order-takeaway-payment`, cartData);

export const createServedOrderPayment = async (cartData: any) => webhookClient.postAnon(`ordering-system/order-served-payment`, cartData);
